// extracted by mini-css-extract-plugin
export default {"section":"VenueSpaces_section__RwaX-","heading":"VenueSpaces_heading__Bde3Y","grid":"VenueSpaces_grid__8jEKi"};